export default __webpack_public_path__ + "static/Client-Testimonial-Joan-f3ad3ef71eb7660e141130efe4bfe606.png";